export const AGREEMENT_OPTIONS = [
    {
        Id: "0",
        Name: "PM1 + Inkasso",
        Value: "1",
    },
    {
        Id: "1",
        Name: "PM1 + PM2 + Inkasso",
        Value: "2"
    },

];